import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from "../../jss-styling.service";
import { JssContextService } from "../../jss-context.service";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-two-link-modal',
  templateUrl: './two-link-modal.component.html',
  styleUrls: ['./two-link-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TwoLinkModalComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() energySave: boolean;

  isVisible = false;
  dynamicClass: string;
  language: string;
  public contextSubscription: Subscription;

  constructor(
    public jssStylingService: JssStylingService,
    public jssContext: JssContextService
  ) {}

  ngOnInit() {
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.contextSubscription = this.jssContext.state.subscribe((newState) => {
      this.language = newState.language
    });
  }

  openModal() {
    this.isVisible = true;
    document.body.style.overflow = 'hidden';
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({ event: 'lightboxOpen' });
  }

  closeModal() {
    this.isVisible = false;
    document.body.style.overflow = 'auto';
  }
}
